 // 表单校验
import { strLength } from "@/utils/index";

export const formRules = { 
  product_id: [{required: true, trigger: "change", message: "请选择课程", }],
  cat_id: [{ required: true, trigger: "change", message: "请选择分类", }],
  is_virtual: [{ required: true }],
  title: [{ required: true, trigger: "blur", validator: (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入课程标题"));
      }
      const len = strLength(value);
      if (len < 16) {
        callback(new Error("课程标题需至少8个汉字或16个字符"));
      }
      callback();
    }
  }],
  pressName: [{ required: true, trigger: "blur", validator: (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请输入出版社名称"));
    }
    callback();
  }
  }],
  isbn: [{ required: true, trigger: "blur", validator: (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请输入isbn编码"));
    }
    callback();
  }
  }],
  price: [
    { required: true, trigger: "blur", message: "请输入课程售价" },
    { trigger: "blur", validator: (rule, value, callback)=>{
      let minMoney = 10
      if(value-0 < minMoney){
        callback(new Error(`价格至少为${minMoney}元`))
      }else{
        callback()
      }
    } }
  ],
  stock: [{ required: true, trigger: "blur", message: "请输入库存数量" }],
  images: [{ required: true, trigger: "blur", validator: (rule, value, callback) => {
      const minPic = 3
      if (!value.length) {
        callback(new Error("请上传轮播图"));
      }else if(value.length<minPic){
        callback(new Error(`请至少上传${minPic}张轮播图`));
      }else{
        callback()
      }
    },
  }],
  image_descriptions: [{ required: true, trigger: "blur", validator: (rule, value, callback) => {
      if (!value.length) {
        callback(new Error("请上传课程介绍图"));
      }else{
        callback()
      }
    } 
  }]
}